import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";

import { ArrowRight, Check, Gift, Users } from "react-feather";
import { FaCoins } from "react-icons/fa";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReferralComponent from "../../Components/ReferralComponent";
import Notiflix from "notiflix";
import GetApiCall from "../../Api/GetApi";
import { toast } from "react-toastify";
import { BANNER_BG, PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../color";
import BannerForm from "../../Components/BannerForm";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { delay } from "../../Helper/ToastDelay";

const ReferralLanding = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [activeTerms, setActiveTerms] = useState(0);
  const primaryColor = "#C16D18";
  const history = useHistory();
  const userdata = JSON.parse(localStorage.getItem("user"));
  const [refferalModal, setRefferalModal] = useState(false);
  const [RefferalData, setRefferalData] = useState({});

  const referHandler = () => {
    if (userdata) {
      getRefferalCode();
      setRefferalModal(true);
    } else {
      history.push("/register");
    }
  };
  const getRefferalCode = async () => {
    try {
      // Show loading indicator
      // Notiflix.Loading.init({ svgColor: "#c16d18" });
      Notiflix.Loading.standard();

      // Make the API request
      const resultdes = await GetApiCall.getRequest("GetJobUserRefer");

      // Try parsing the response as JSON
      const obj = await resultdes.json();

      if (resultdes.ok) {
        // If the response is OK, set referral data
        setRefferalData(obj?.data);
      } else {
        // Handle API errors (e.g., 4xx or 5xx status codes)

        toast.error(obj?.message || "Failed to fetch referral data.");
      }
    } catch (error) {
      toast.error(SomethingWrong, {
        autoClose: delay,
        toastId: 1,
      });
    } finally {
      // Always remove the loading indicator
      Notiflix.Loading.remove();
    }
  };
  const Step = ({ imageSrc, altText, stepNumber, title, description }) => {
    return (
      <Col lg={3} md={6} sm={12} className="text-center mb-4">
        <div
          style={{
            width: "90px",
            height: "90px",
            backgroundColor: "white",
            overflow: "hidden",
          }}
          className="mx-auto "
        >
          <img
            src={imageSrc}
            alt={altText}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        <h3>{stepNumber}</h3>
        <h5 style={{ color: PRIMARY_COLOR }}> {title}</h5>
        <p style={{ color: PRIMARY_TEXT_COLOR, fontSize: "12px" }}>
          {description}
        </p>
      </Col>
    );
  };
  // const Step = ({ imageSrc, altText, stepNumber, title, description }) => {
  //   return (
  //     <Col lg={3} md={6} sm={12} className="text-center mb-4">
  //       {/* Image Container */}
  //       <div
  //         className="mx-auto d-flex justify-content-center align-items-center rounded-circle shadow"
  //         style={{
  //           width: "90px",
  //           height: "90px",
  //           backgroundColor: "white",
  //           overflow: "hidden",
  //         }}
  //       >
  //         <img
  //           src={imageSrc}
  //           alt={altText}
  //           className="w-100 h-100 object-fit-cover"
  //         />
  //       </div>

  //       {/* Step Number */}
  //       <h3 className="mt-3 fs-4">{stepNumber}</h3>

  //       {/* Title */}
  //       <h5 className="text-primary fw-bold">{title}</h5>

  //       {/* Description */}
  //       <p className="text-muted fs-6">{description}</p>
  //     </Col>
  //   );
  // };

  const steps = [
    {
      imageSrc: "/assets/img/app.png",
      altText: "Login Icon",
      title: "Register & Login",
      description:
        'Login/Sign up and get your referral link on "Refer and Earn" page',
    },
    {
      imageSrc: "/assets/img/share.png",
      altText: "Share Icon",
      title: "Share Referral Link",
      description: "Share your referral link with your family/friends",
    },
    {
      imageSrc: "/assets/img/terms.png",
      altText: "Shop Icon",
      title: "Referral Completes Onboarding",
      description:
        "Referral need to complete the onboarding process and submit documents.",
    },
    {
      imageSrc: "/assets/img/reward.png",
      altText: "Reward Icon",
      title: "Get Rewarded",
      description:
        "Reward instantly credit in your wallet. You can withdraw it when the referral completes its first audit.",
    },
  ];

  return (
    <div className="min-vh-100">
      {/* Hero Banner Section */}
      <div
        className="position-relative overflow-hidden"
        style={{
          background: BANNER_BG,
        }}
      >
        <Container className="py-5 mt-5">
          <Row className="align-items-center gy-4">
            <Col lg={6} className="text-center text-lg-start">
              {/* <div className="d-inline-flex align-items-center gap-2 bg-white rounded-pill px-3 py-2">
                <Gift size={18} style={{ color: primaryColor }} />
                <p className="fw-medium ml-2" style={{ color: primaryColor }}>
                  New year offer
                </p>
              </div> */}
              {/* <div className="d-inline-flex align-items-center gap-2 bg-white rounded-pill px-3 py-2">
                <p className="fw-medium ml-2" style={{ color: primaryColor }}>
                  <Gift size={18} style={{ color: primaryColor }} />
                  <span> New year offer</span>

                  <p
                    className="opacity-75 text-dark"
                    style={{ fontSize: "9px", color: primaryColor }}
                  >
                    valid upto 31st Jan 2025
                  </p>
                </p>
              </div> */}
              <div className="d-inline-flex align-items-center gap-2 bg-white rounded-pill px-3 py-2 mb-4">
                <Gift size={18} style={{ color: primaryColor }} />
                <div className="fw-medium ml-2" style={{ color: primaryColor }}>
                  <span>Limited time offer!</span>
                  <span
                    className="opacity-75 text-dark"
                    style={{
                      fontSize: "9px",
                      display: "block",
                      marginTop: "0",
                    }}
                  >
                    valid upto 30st June 2025
                  </span>
                </div>
              </div>

              <h1
                className="display-6 fw-bold mb-3 bannerText"
                // className="display-4 fw-bold mb-4"
                style={{ color: primaryColor }}
              >
                Help your friends <br /> join and grow with you!
              </h1>

              <p
                className="lead mb-2 opacity-75 text-dark "
                style={{ color: PRIMARY_TEXT_COLOR }}
              >
                {/* Limited time offer! <br /> */}
                Refer a friend to & receive&nbsp;
                <span className="fw-bold" style={{ color: primaryColor }}>
                  ₹200
                </span>{" "}
              </p>
              <p style={{ fontSize: "10px" }}>
                <a
                  // className="opacity-75"
                  style={{ color: "black", scrollBehavior: "smooth" }}
                  href="#terms-condition-section"
                >
                  *Terms & Conditions Apply
                </a>
              </p>
              {/*  */}

              <Button
                onClick={referHandler}
                style={{ backgroundColor: primaryColor, border: "none" }}
                className="d-inline-flex align-items-center px-4 py-2 mt-2"
              >
                {userdata ? "Refer a Friend" : "Create Account Now"}
                <ArrowRight size={20} className="ms-2" />
              </Button>
            </Col>

            <Col lg={6} className="text-center position-relative">
              <div className="position-relative d-inline-block">
                <img
                  src={"/assets/img/ttt.png"}
                  alt="Community rewards"
                  className="img-fluid "
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* Refer steps */}
      <Container>
        <h4 className="text-center my-5 section-title text-dark">
          How it works ?
        </h4>
        <Row>
          {steps.map((step, index) => (
            <Step
              key={index}
              imageSrc={step.imageSrc}
              altText={step.altText}
              stepNumber={index + 1}
              title={step.title}
              description={step.description}
            />
          ))}
        </Row>
      </Container>

      {/* Why Join Section */}
      <Container className="py-5">
        <h4 className="text-center mb-5 section-title text-dark">
          Why Join Our Community ?
        </h4>
        <Row className="g-4">
          {[
            {
              icon: Gift,
              title: "Instant Rewards",
              description: "Create your account now before it's too late !",
            },
            {
              icon: Users,
              title: "Friend Bonuses",
              description:
                "Earn additional rewards for every friend who joins through your referral",
            },
            {
              icon: FaCoins,
              title: "Exclusive Benefits",
              description:
                "Access special promotions and milestone rewards as you grow",
            },
          ].map((benefit, index) => (
            <Col md={4} key={index} className="mb-2">
              <Card className="border-0 h-100 text-center shadow hover-card">
                <CardBody className="p-4">
                  <div
                    className="rounded-circle mx-auto mb-4 p-3"
                    style={{
                      backgroundColor: `${primaryColor}20`,
                      width: "80px",
                      height: "80px",
                    }}
                  >
                    <benefit.icon size={40} style={{ color: primaryColor }} />
                  </div>
                  <CardTitle
                    tag="h3"
                    style={{ fontSize: "1.25rem", color: PRIMARY_TEXT_COLOR }}
                    className="mb-3"
                  >
                    {benefit.title}
                  </CardTitle>
                  <CardText
                    className="text-muted"
                    style={{ color: PRIMARY_TEXT_COLOR }}
                  >
                    {benefit.description}
                  </CardText>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* Terms Section */}
      <Container className="py-5" id="terms-condition-section">
        <Row className="justify-content-center">
          <Col>
            <Card className="border-0 shadow-sm">
              <CardBody className="p-4">
                <h4 className="text-center mb-5 section-title text-dark">
                  Program Overview
                </h4>
                {/* <h3 className="mb-4" style={{ color: primaryColor }}>
                 
                </h3> */}

                <Row className="g-4">
                  <Col md={6}>
                    <div
                      className={`p-4 rounded-3 ${
                        activeTerms === 0 ? "bg-light" : ""
                      }`}
                      onClick={() => setActiveTerms(0)}
                      style={{ cursor: "pointer" }}
                    >
                      <h5
                        className="mb-3"
                        style={{ color: PRIMARY_TEXT_COLOR }}
                      >
                        Referral Eligibility
                      </h5>
                      <div className="text-muted">
                        {[
                          "Must be an existing user with a verified account.",
                          "Referrer and referee both should not be employee or contractor.",
                          "Age should be 18 year or above",
                          // "Must match the job criteria.",
                        ].map((item, idx) => (
                          <div
                            key={idx}
                            className="d-flex align-items-start gap-2 mb-2"
                          >
                            <Check
                              size={18}
                              style={{ color: primaryColor }}
                              className="flex-shrink-0 mt-1"
                            />
                            <span style={{ color: PRIMARY_TEXT_COLOR }}>
                              {item}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>

                  <Col md={6}>
                    <div
                      className={`p-4 rounded-3 ${
                        activeTerms === 1 ? "bg-light" : ""
                      }`}
                      onClick={() => setActiveTerms(1)}
                      style={{ cursor: "pointer" }}
                    >
                      <h5
                        className="mb-3"
                        style={{ color: PRIMARY_TEXT_COLOR }}
                      >
                        Reward Conditions
                      </h5>
                      <div className="text-muted">
                        {[
                          "Referred users must complete verification .",
                          "The more you refer, the more you earn .",
                          "Redeem your reward when your referral completes their first audit .",
                        ].map((item, idx) => (
                          <div
                            key={idx}
                            className="d-flex align-items-start gap-2 mb-2"
                          >
                            <Check
                              size={18}
                              style={{ color: primaryColor }}
                              className="flex-shrink-0 mt-1"
                            />
                            <span style={{ color: PRIMARY_TEXT_COLOR }}>
                              {item}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Register now */}
      <div className="mt-3 py-3 bg-light">
        <Container>
          <h4 className="text-center mb-2 mt-3 section-title text-dark">
            Ready to Get Started?
          </h4>
          <Row>
            <Col md={6} sm={12}>
              <img
                src={"/assets/img/rb_21676.png"}
                alt="Community rewards"
                className="img-fluid "
              />
            </Col>
            <Col></Col>
            <Col md={4} sm={12}>
              <BannerForm />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Terms Modal */}
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(false)} size="lg">
        <ModalHeader toggle={() => setModalOpen(false)}>
          Complete Terms & Conditions
        </ModalHeader>
        <ModalBody className="p-4">
          <div className="mb-4">
            <h5 className="mb-3">1. Program Overview</h5>
            <p className="text-muted">
              Our referral program rewards users for inviting friends to join
              our platform. Both the referrer and referee receive benefits when
              specific conditions are met.
            </p>
          </div>

          {/* Rest of the modal content remains the same... */}
        </ModalBody>
      </Modal>

      <style>
        {`
          .hover-card {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .hover-card:hover {
            transform: translateY(-10px);
            box-shadow: 0 1rem 3rem rgba(0,0,0,.175)!important;
          }
          .rounded-4 {
            border-radius: 1rem!important;
          }
          @media (max-width: 576px) {
            .container {
              padding-left: 1.25rem;
              padding-right: 1.25rem;
            }
          }
        `}
      </style>
      {refferalModal === true && (
        <ReferralComponent
          modal={refferalModal}
          setModal={setRefferalModal}
          user={userdata}
          RefferalData={RefferalData}
        />
      )}
    </div>
  );
};

export default ReferralLanding;
